import { isUsageTimeLimitError } from '@/lib/auth/usageTimeLimitLockout';

/** True for 403-style API errors that will not succeed on retry. */
export function isForbiddenError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const code = error.message;
  return code.endsWith('.authorization.forbidden');
}

/** True when the API reports that the requested record does not exist. */
export function isNotFoundError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return error.message.includes('.not_found');
}

/** Errors that should fail the query immediately instead of retrying. */
export function isNonRetryableApiError(error: unknown): boolean {
  return isUsageTimeLimitError(error) || isForbiddenError(error);
}

export function getApiErrorCode(data: unknown): string | undefined {
  if (!data || typeof data !== 'object') return undefined;
  const { code, message } = data as { code?: unknown; message?: unknown };
  if (typeof code === 'string' && code.length > 0) return code;
  if (typeof message === 'string' && message.length > 0) return message;
  return undefined;
}
